export default __webpack_public_path__ + "static/integration-test-47aa8021f3bb719e5a5d2f1d4cd5e796.webp";